export const sitemap = {
    header: "Sitemap",
};
